import {AccessoryCategoriesComponent} from './settings/accessory-categories/accessory-categories.component';
import {
  AccessoriesFormComponent
} from './settings/material-codes-accessories/accessories-form/accessories-form.component';
import { CreateRefrigeratorRequestDialogComponent} from './sale-point-details/create-refrigerator-request-dialog/create-refrigerator-request-dialog.component';
import {CommandAccessoriesDialogComponent} from '../app/loading-orders/loading-order-details-info/command-accessories-dialog/command-accessories-dialog.component';
import { RefrigeratorSelectionDialogComponent} from './repair-order-form/refrigerator-selection-dialog/refrigerator-selection-dialog.component';
import { SuperMarketBudgetFileInfoDialogComponent} from './super-market-budget/dialogs/super-market-budget-file-info-dialog/super-market-budget-file-info-dialog.component';
import { SuperMarketKeyAccountDialogComponent} from './settings/super-market-key-account/super-market-key-account-dialog/super-market-key-account-dialog.component';
import { UpdateRefrigeratorSerialNumberDialogComponent} from './table/update-refrigerator-serial-number-dialog/update-refrigerator-serial-number-dialog.component';
import { UploadSuperMarketKeyAccountDialogComponent} from './settings/super-market-key-account/upload-super-market-key-account-dialog/upload-super-market-key-account-dialog.component';
import {ActionCompletionDialogComponent} from './common/action-completion-dialog/action-completion-dialog.component';
import {AddNotesCommentsComponent} from './recycle-details/dialogs/add-notes-comments/add-notes-comments.component';
import {AddRefrigeratorDialogComponent} from './sale-point-details/add-refrigerator-dialog/add-refrigerator-dialog.component';
import {AddRefrigeratorFirstStepComponent} from './sale-point-details/add-refrigerator-dialog/first-step/add-refrigerator-first-step.component';
import {AddRefrigeratorSecondStepComponent} from './sale-point-details/add-refrigerator-dialog/second-step/add-refrigerator-second-step.component';
import {AgreementDetailsComponent} from './agreements/agreement-details/agreement-details.component';
import {AgreementsComponent} from './agreements/agreements.component';
import {AppComponent} from './app.component';
import {AppErrorHandler} from './common/app-error-handler';
import {AppRoutingModule} from './app-routing.module';
import {AssignAndDetailModalComponent} from './common/assign-and-detail-modal/assign-and-detail-modal.component';
import {AssignRequestComponent} from './return-refrigerator-details/assign-request/assign-request.component';
import {AssingQuestionnaireDialogComponent} from './questionaires/assing-questionnaire-dialog/assing-questionnaire-dialog.component';
import {AssingRecycleFormComponent} from './recycle-details/dialogs/assing-recycle/assign-recycle-form.component';
import {AssingSaleFormComponent} from './sale-details/dialogs/assing-sale/assign-sale-form.component';
import {AuthInterceptor} from './interceptors/auth.service';
import {AutomationsComponent} from './settings/automations/automations.component';
import {BasicDetailsComponent} from './details/basic-details/basic-details.component';
import {BasicInfoComponent} from './common/basic-info/basic-info.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import {BrowserModule} from '@angular/platform-browser';
import {BudgetFileInfoDialogComponent} from './budget/refrigerator-old-budget/budget-file-info-dialog/budget-file-info-dialog.component';
import {BudgetLogsComponent} from './budget/refrigerator-old-budget/budget-logs/budget-logs.component';
import {BudgetSettingsComponent} from './budget/refrigerator-old-budget/budget-settings/budget-settings.component';
import {BudgetTableComponent} from './budget/refrigerator-old-budget/budget-table/budget-table.component';
import {CancellationMaterialDialogComponent} from './loading-orders/loading-order-details/cancellation-material-dialog/cancellation-material-dialog.component';
import {CancellationOrderDialogComponent} from './common/cancellation-order-dialog/cancellation-order-dialog.component';
import {ConfirmActionDialogComponent} from './common/confirm-action-dialog/confirm-action-dialog.component';
import {ConfirmationDialogComponent} from './repair-details/confirmation-dialog/confirmation-dialog.component';
import {CookieService} from 'ngx-cookie-service';
import {CreateDialogComponent} from './questionaires/create-dialog/create-dialog.component';
import {CreateInventoryDialogComponent} from './users/user-details/create-inventory-dialog/create-inventory-dialog.component';
import {CreateLoadingDialogComponent} from './users/user-details/create-loading-dialog/create-loading-dialog.component';
import {CreateLoadingRequestComponent} from './common/create-loading-request/create-loading-request.component';
import {CreateNewDialogComponent} from './settings/create-new-dialog/create-new-dialog.component';
import {CreateReceiptDialogComponent} from './users/user-details/create-receipt-dialog/create-receipt-dialog.component';
import {CreateReturnRequestDialogComponent} from './sale-point-details/create-return-request-dialog/create-return-request-dialog.component';
import {CreateUnloadingRequestComponent} from './common/create-unloading-request/create-unloading-request.component';
import {CustomLoadingComponent} from './common/custom-loading/custom-loading.component';
import {DetailsDialogComponent} from './common/details-dialog/details-dialog.component';
import {DistributionLocationsLimitsComponent} from './distribution-locations-limits/distribution-locations-limits.component';
import {EditDetailsFormComponent} from './repair-details/edit-details-form/edit-details-form.component';
import {EditLoadingOrderSerialNumberComponent} from './common/edit-loading-order-serial-number/edit-loading-order-serial-number.component';
import {EditReturnOrderSerialNumberComponent} from './common/edit-return-order-serial-number/edit-return-order-serial-number.component';
import {EditUserDialogComponent} from './users/user-details/edit-user-dialog/edit-user-dialog.component';
import {ErrorComponent} from './error/error.component';
import {ErrorDialogComponent} from './common/error-dialog/error-dialog.component';
import {ErrorHandler, NgModule} from '@angular/core';
import {EvaluatedRefrigeratorDetailsComponent} from './evaluation/evaluated-refrigerator-details/evaluated-refrigerator-details.component';
import {EvaluatedRefrigeratorsComponent} from './evaluation/evaluated-refrigerators/evaluated-refrigerators.component';
import {EvaluationComponent} from './evaluation/evaluation.component';
import {EvaluationSettingsComponent} from './evaluation/evaluation-settings/evaluation-settings.component';
import {EventLogsComponent} from './common/event-logs/event-logs.component';
import {FailuresDialogComponent} from './receipt-orders/receiving-order-details/failures-dialog/failures-dialog.component';
import {FilterTableDialogComponent} from './table/filter-table-dialog/filter-table-dialog.component';
import {FlexLayoutModule} from '@angular/flex-layout';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {HTTP_INTERCEPTORS, HttpClientModule} from '@angular/common/http';
import {HashLocationStrategy, LocationStrategy} from '@angular/common';
import {HeadQuartersComponent} from './settings/head-quarters/head-quarters.component';
import {HelpComponent} from './help/help.component';
import {HomeComponent} from './home/home.component';
import {InitializeSumsDialogComponent} from './refrigerator-budget/initialize-sums-dialog/initialize-sums-dialog.component';
import {InventoryDetailsComponent} from './inventory-details/inventory-details.component';
import {InventoryRefrigeratorsDialogComponent} from './inventory-details/inventory-refrigerators-dialog/inventory-refrigerators-dialog.component';
import {ItemGroupsFactorsComponent} from './settings/item-groups-factors/item-groups-factors.component';
import {KeyAccountSecondStepModule} from './settings/super-market-key-account/upload-super-market-key-account-dialog/key-account-second-step/key-account-second-step.module';
import {LayoutComponent} from './layout/layout.component';
import {LayoutModule} from '@angular/cdk/layout';
import {LoadingComponent} from './common/loading/loading.component';
import {LoadingOrderDetailsComponent} from './loading-orders/loading-order-details/loading-order-details.component';
import {LoadingOrderDetailsInfoComponent} from './loading-orders/loading-order-details-info/loading-order-details-info.component';
import {LoadingOrdersComponent} from './loading-orders/loading-orders.component';
import {Location} from '@angular/common';
import {LoginComponent} from './login/login.component';
import {LogoutDialogComponent} from './logout-dialog/logout-dialog.component';
import {LogsComponent} from './repair-details/logs/logs.component';
import {MainNavComponent} from './main-nav/main-nav.component';
import {MaintenanceFormComponent} from './maintenance-form/maintenance-form.component';
import {MatButtonModule} from '@angular/material/button';
import {MatFormFieldModule, MatSelectModule} from '@angular/material';
import {MatIconModule} from '@angular/material/icon';
import {MatListModule} from '@angular/material/list';
import {MatSelectInfiniteScrollModule} from 'ng-mat-select-infinite-scroll';
import {MatSidenavModule} from '@angular/material/sidenav';
import {MatToolbarModule} from '@angular/material/toolbar';
import {MatTree} from '@angular/material';
import {
  MaterialAccessoriesDialogComponent
} from './request-order-details/material-accessories-dialog/material-accessories-dialog.component';
import {MaterialCodesAccessoriesComponent} from './settings/material-codes-accessories/material-accessories.component';
import {MaterialModule} from './material/material.module';
import {MergingDialogComponent} from './settings/merging-sale-points/merging-dialog/merging-dialog.component';
import {MergingSalePointsComponent} from './settings/merging-sale-points/merging-sale-points.component';
import {MiniTableAgreementInfoComponent} from './agreements/mini-table-agreement-info/mini-table-agreement-info.component';
import {NestedTableComponent} from './settings/nested-table/nested-table.component';
import {NewNotificationComponent} from './settings/automations/dialogs/new-notification/new-notification.component';
import {NgxBarcodeModule} from 'ngx-barcode';
import {NgxMaskModule} from 'ngx-mask';
import {NgxMatSelectSearchModule} from 'ngx-mat-select-search';
import {NgxPrintModule} from 'ngx-print';
import {NotificationsComponent} from './notifications/notifications.component';
import {OptionsDialogComponent} from './questionaires/options-dialog/options-dialog.component';
import {OrderDetailsComponent} from './order-details/order-details.component';
import {PdfCreatorComponent} from './common/pdf-creator/pdf-creator.component';
import {PdfSampleComponent} from './pdf-sample/pdf-sample.component';
import {ProgressDialogComponent} from './common/progress-dialog/progress-dialog.component';
import {PromoDetailsComponent} from './promo-details/promo-details.component';
import {QuestionairesComponent} from './questionaires/questionaires.component';
import {QuestionnairAssignementWizardDialogComponent} from './questionaires/questionnair-assignement-wizard-dialog/questionnair-assignement-wizard-dialog.component';
import {QuestionnaireCreatorComponent} from './questionaires/questionnaire-creator/questionnaire-creator.component';
import {QuestionnaireDetailsComponent} from './questionaires/questionnaire-details/questionnaire-details.component';
import {QuestionsDialogComponent} from './questionaires/questions-dialog/questions-dialog.component';
import {ReceiptOrdersComponent} from './receipt-orders/receipt-orders.component';
import {ReceivingOrderDetailsComponent} from './receipt-orders/receiving-order-details/receiving-order-details.component';
import {ReceivingOrderDetailsInfoComponent} from './receipt-orders/receiving-order-details-info/receiving-order-details-info.component';
import {RecycleDetailsComponent} from './recycle-details/recycle-details.component';
import {RedistributionDialogComponent} from './super-market-budget/components/budget/redistribution-dialog/redistribution-dialog.component';
import {RedistributionFirstStepComponent} from './super-market-budget/components/budget/redistribution-dialog/first-step/redistribution-first-step.component';
import {RedistributionSecondStepComponent} from './super-market-budget/components/budget/redistribution-dialog/second-step/redistribution-second-step.component';
import {RefrigeratorBudgetComponent} from './refrigerator-budget/refrigerator-budget.component';
import {RefrigeratorDetailsComponent} from './refrigerator-details/refrigerator-details.component';
import {RefrigeratorOldBudgetComponent} from './budget/refrigerator-old-budget/refrigerator-old-budget.component';
import {RegionalBudgetComponent} from './budget/refrigerator-old-budget/regional-budget/regional-budget.component';
import {RepairDetailsComponent} from './repair-details/repair-details.component';
import {RepairOrderFormComponent} from './repair-order-form/repair-order-form.component';
import {RequestOrderDetailsComponent} from './request-order-details/request-order-details.component';
import {ReturnReasonsComponent} from './settings/return-reasons/return-reasons.component';
import {ReturnRefrigeratorDetailsComponent} from './return-refrigerator-details/return-refrigerator-details.component';
import {SMBudgetComponent} from './super-market-budget/components/budget/sm-budget.component';
import {SMLogsComponent} from './super-market-budget/components/logs/sm-logs.component';
import {SMSettingsComponent} from './super-market-budget/components/settings/sm-settings.component';
import {SaleDetailsComponent} from './sale-details/sale-details.component';
import {SalePointAgreementComponent} from './sale-point-details/sale-point-agreement/sale-point-agreement.component';
import {SalePointComponent} from './sale-point/sale-point.component';
import {SalePointDetailsComponent} from './sale-point-details/sale-point-details.component';
import {SalePointVersionDetailsComponent} from './sale-point-version-details/sale-point-version-details.component';
import {SalePointPlirotisDialogComponent} from './settings/sale-point-plirotis/sale-point-plirotis-dialog/sale-point-plirotis-dialog.component';
import {SalePointPlirotisComponent} from './settings/sale-point-plirotis/sale-point-plirotis.component';
import {SalesGroupManagementComponent} from './settings/sales-group-management/sales-group-management.component';
import {SecondStepModule} from './budget/refrigerator-old-budget/upload-budget-dialog/second-step/second-step.module';
import {SelectionDialogComponent} from './questionaires/assing-questionnaire-dialog/selection-dialog/selection-dialog.component';
import {SettingsComponent} from './settings/settings.component';
import {SimpleConfirmActionDialogComponent} from './common/simple-confirm-action-dialog/simple-confirm-action-dialog.component';
import {SocketIoConfig, SocketIoModule} from 'ngx-socket-io';
import {SparePartFormComponent} from './settings/spare-parts/spare-part-form/spare-part-form.component';
import {SparePartsComponent} from './settings/spare-parts/spare-parts.component';
import {StatisticsComponent} from './statistics/statistics.component';
import {SuperMarketBudgetComponent} from './super-market-budget/super-market-budget.component';
import {SuperMarketKeyAccountComponent} from './settings/super-market-key-account/super-market-key-account.component';
import {SuperMarketUploadBudgetDialogComponent} from './super-market-budget/dialogs/super-market-upload-budget-dialog/super-market-upload-budget-dialog.component';
import {SuperMarketUploadSecondStepModule} from './super-market-budget/dialogs/super-market-upload-budget-dialog/second-step/super-market-upload-second-step.module';
import {TableComponent} from './table/table.component';
import {TotalBudgetComponent} from './budget/refrigerator-old-budget/total-budget/total-budget.component';
import {TwoStepDialogComponent} from './login/two-step-dialog/two-step-dialog.component';
import {UpdateSerialNumberDialogComponent} from './common/update-serial-number-dialog/update-serial-number-dialog.component';
import {UploadAttachmentModule} from './layout/components/upload-attachment/upload-attachment.module';
import {UploadBudgetDialogComponent} from './budget/refrigerator-old-budget/upload-budget-dialog/upload-budget-dialog.component';
import {UploadSalePointPlirotisDialogComponent} from './settings/sale-point-plirotis/upload-sale-point-plirotis-dialog/upload-sale-point-plirotis-dialog.component';
import {UsedBudgetComponent} from './budget/refrigerator-old-budget/used-budget/used-budget.component';
import {UserBasicComponent} from './users/user-basic/user-basic.component';
import {UserDetailsComponent} from './users/user-details/user-details.component';
import {UserFormComponent} from './users/user-form/user-form.component';
import {WithdrawalDetailsComponent} from './withdrawal-details/withdrawal-details.component';
import {environment} from '../environments/environment';
import {
  SalePointPlirotisSecondStepModule
} from './settings/sale-point-plirotis/upload-sale-point-plirotis-dialog/sale-point-plirotis-second-step/sale-point-plirotis-second-step.module';
import {
  RefrigeratorTransferDetailsComponent
} from './refrigerator-transfer-details/refrigerator-transfer-details.component';
import {
  RouteTransferFormComponent
} from './refrigerator-transfers/components/route-transfer-form/route-transfer-form.component';
import {RefrigeratorTransfersComponent} from './refrigerator-transfers/refrigerator-transfers.component';
import {
  PreviewInfoDialogComponent
} from './refrigerator-transfer-details/preview-info-dialog/preview-info-dialog.component';
import {DragDropModule} from '@angular/cdk/drag-drop';
import { AccessoryRequestReasonsComponent
} from './settings/accessory-request-reasons/accessory-request-reasons.component';
import {RequestOrderComponent} from './request-order/request-order.component';
import {AccessoryRequestDetailsComponent} from './accessory-request-details/accessory-request-details.component';
import {
  CreateLoadingAccessoryRequestComponent
} from './accessory-request-details/loading-order-creation/create-loading-accessory-request.component';
import {
  AccessoryLoadingOrderDetailsComponent
} from './accessory-loading-order-details/accessory-loading-order-details.component';
import {
  CancellationAccessoryLoadingDialogComponent
} from './accessory-loading-order-details/cancellation-accessory-loading-dialog/cancellation-accessory-loading-dialog.component';

const config: SocketIoConfig = {
  url: environment.socketUrl,
  options: {}
};

@NgModule({
  bootstrap: [AppComponent],
  declarations: [
    AccessoryLoadingOrderDetailsComponent,
    AccessoryRequestDetailsComponent,
    AccessoryRequestReasonsComponent,
    AccessoriesFormComponent,
    AccessoryCategoriesComponent,
    ActionCompletionDialogComponent,
    AddNotesCommentsComponent,
    AddRefrigeratorDialogComponent,
    AddRefrigeratorFirstStepComponent,
    AddRefrigeratorSecondStepComponent,
    AgreementDetailsComponent,
    AgreementsComponent,
    AppComponent,
    AssignAndDetailModalComponent,
    AssignRequestComponent,
    AssingQuestionnaireDialogComponent,
    AssingRecycleFormComponent,
    AssingSaleFormComponent,
    AutomationsComponent,
    BasicDetailsComponent,
    BasicInfoComponent,
    BudgetFileInfoDialogComponent,
    BudgetLogsComponent,
    BudgetSettingsComponent,
    BudgetTableComponent,
    CancellationAccessoryLoadingDialogComponent,
    CancellationMaterialDialogComponent,
    CancellationOrderDialogComponent,
    CommandAccessoriesDialogComponent,
    ConfirmActionDialogComponent,
    ConfirmationDialogComponent,
    CreateDialogComponent,
    CreateInventoryDialogComponent,
    CreateLoadingAccessoryRequestComponent,
    CreateLoadingDialogComponent,
    CreateLoadingDialogComponent,
    CreateLoadingRequestComponent,
    CreateNewDialogComponent,
    CreateReceiptDialogComponent,
    CreateReceiptDialogComponent,
    CreateRefrigeratorRequestDialogComponent,
    CreateReturnRequestDialogComponent,
    CreateUnloadingRequestComponent,
    CustomLoadingComponent,
    DetailsDialogComponent,
    DistributionLocationsLimitsComponent,
    EditDetailsFormComponent,
    EditLoadingOrderSerialNumberComponent,
    EditReturnOrderSerialNumberComponent,
    EditUserDialogComponent,
    ErrorComponent,
    ErrorDialogComponent,
    EvaluatedRefrigeratorDetailsComponent,
    EvaluatedRefrigeratorsComponent,
    EvaluationComponent,
    EvaluationSettingsComponent,
    EventLogsComponent,
    FailuresDialogComponent,
    FilterTableDialogComponent,
    HeadQuartersComponent,
    HelpComponent,
    HomeComponent,
    InitializeSumsDialogComponent,
    InventoryDetailsComponent,
    InventoryRefrigeratorsDialogComponent,
    ItemGroupsFactorsComponent,
    LayoutComponent,
    LoadingComponent,
    LoadingOrderDetailsComponent,
    LoadingOrderDetailsInfoComponent,
    LoadingOrdersComponent,
    LoginComponent,
    LogoutDialogComponent,
    LogsComponent,
    MainNavComponent,
    MaintenanceFormComponent,
    MaterialAccessoriesDialogComponent,
    MaterialCodesAccessoriesComponent,
    MergingDialogComponent,
    MergingSalePointsComponent,
    MiniTableAgreementInfoComponent,
    NestedTableComponent,
    NewNotificationComponent,
    NotificationsComponent,
    OptionsDialogComponent,
    OrderDetailsComponent,
    PdfCreatorComponent,
    PdfSampleComponent,
    PreviewInfoDialogComponent,
    ProgressDialogComponent,
    PromoDetailsComponent,
    QuestionairesComponent,
    QuestionnairAssignementWizardDialogComponent,
    QuestionnaireCreatorComponent,
    QuestionnaireDetailsComponent,
    QuestionsDialogComponent,
    ReceiptOrdersComponent,
    ReceivingOrderDetailsComponent,
    ReceivingOrderDetailsInfoComponent,
    RecycleDetailsComponent,
    RedistributionDialogComponent,
    RedistributionFirstStepComponent,
    RedistributionSecondStepComponent,
    RefrigeratorBudgetComponent,
    RefrigeratorDetailsComponent,
    RefrigeratorOldBudgetComponent,
    RefrigeratorSelectionDialogComponent,
    RefrigeratorTransferDetailsComponent,
    RefrigeratorTransfersComponent,
    RegionalBudgetComponent,
    RepairDetailsComponent,
    RepairOrderFormComponent,
    RequestOrderComponent,
    RequestOrderDetailsComponent,
    ReturnReasonsComponent,
    ReturnRefrigeratorDetailsComponent,
    RouteTransferFormComponent,
    SMBudgetComponent,
    SMLogsComponent,
    SMSettingsComponent,
    SaleDetailsComponent,
    SalePointAgreementComponent,
    SalePointComponent,
    SalePointDetailsComponent,
    SalePointPlirotisComponent,
    SalePointPlirotisDialogComponent,
    SalePointVersionDetailsComponent,
    SalesGroupManagementComponent,
    SelectionDialogComponent,
    SettingsComponent,
    SimpleConfirmActionDialogComponent,
    SparePartFormComponent,
    SparePartsComponent,
    StatisticsComponent,
    SuperMarketBudgetComponent,
    SuperMarketBudgetFileInfoDialogComponent,
    SuperMarketKeyAccountComponent,
    SuperMarketKeyAccountDialogComponent,
    SuperMarketUploadBudgetDialogComponent,
    TableComponent,
    TotalBudgetComponent,
    TwoStepDialogComponent,
    UpdateRefrigeratorSerialNumberDialogComponent,
    UpdateSerialNumberDialogComponent,
    UploadBudgetDialogComponent,
    UploadSalePointPlirotisDialogComponent,
    UploadSuperMarketKeyAccountDialogComponent,
    UsedBudgetComponent,
    UserBasicComponent,
    UserDetailsComponent,
    UserFormComponent,
    WithdrawalDetailsComponent,
  ],
    imports: [
        AppRoutingModule,
        BrowserAnimationsModule,
        BrowserModule,
        FlexLayoutModule,
        FormsModule,
        HttpClientModule,
        KeyAccountSecondStepModule,
        LayoutModule,
        MatButtonModule,
        MatFormFieldModule,
        MatIconModule,
        MatListModule,
        MatSelectInfiniteScrollModule,
        MatSelectModule,
        MatSidenavModule,
        MatToolbarModule,
        MaterialModule,
        NgxBarcodeModule,
        NgxMaskModule.forRoot({}),
        NgxMatSelectSearchModule,
        NgxPrintModule,
        ReactiveFormsModule,
        SecondStepModule,
        SocketIoModule.forRoot(config),
        SuperMarketUploadSecondStepModule,
        UploadAttachmentModule,
        SalePointPlirotisSecondStepModule,
        DragDropModule
    ],
  entryComponents: [
    AccessoriesFormComponent,
    AddNotesCommentsComponent,
    AddRefrigeratorDialogComponent,
    AssignAndDetailModalComponent,
    AssignRequestComponent,
    AssingQuestionnaireDialogComponent,
    AssingRecycleFormComponent,
    AssingSaleFormComponent,
    BudgetFileInfoDialogComponent,
    CancellationAccessoryLoadingDialogComponent,
    CancellationMaterialDialogComponent,
    CancellationOrderDialogComponent,
    CommandAccessoriesDialogComponent,
    ConfirmationDialogComponent,
    CreateDialogComponent,
    CreateLoadingAccessoryRequestComponent,
    CreateLoadingDialogComponent,
    CreateLoadingRequestComponent,
    CreateNewDialogComponent,
    CreateReceiptDialogComponent,
    CreateRefrigeratorRequestDialogComponent,
    CreateReturnRequestDialogComponent,
    CreateUnloadingRequestComponent,
    CustomLoadingComponent,
    EditDetailsFormComponent,
    EditLoadingOrderSerialNumberComponent,
    EditReturnOrderSerialNumberComponent,
    FailuresDialogComponent,
    InitializeSumsDialogComponent,
    MaterialAccessoriesDialogComponent,
    MergingDialogComponent,
    MiniTableAgreementInfoComponent,
    NewNotificationComponent,
    OptionsDialogComponent,
    PdfCreatorComponent,
    PreviewInfoDialogComponent,
    ProgressDialogComponent,
    QuestionnairAssignementWizardDialogComponent,
    QuestionsDialogComponent,
    RedistributionDialogComponent,
    RedistributionDialogComponent,
    RefrigeratorSelectionDialogComponent,
    RefrigeratorTransfersComponent,
    RouteTransferFormComponent,
    SMBudgetComponent,
    SMLogsComponent,
    SMSettingsComponent,
    SalePointPlirotisComponent,
    SalePointPlirotisDialogComponent,
    SelectionDialogComponent,
    SimpleConfirmActionDialogComponent,
    SparePartFormComponent,
    SuperMarketBudgetFileInfoDialogComponent,
    SuperMarketKeyAccountComponent,
    SuperMarketKeyAccountDialogComponent,
    SuperMarketUploadBudgetDialogComponent,
    TwoStepDialogComponent,
    UpdateSerialNumberDialogComponent,
    UploadBudgetDialogComponent,
    UploadSalePointPlirotisDialogComponent,
    UploadSuperMarketKeyAccountDialogComponent
  ],
  providers: [
    CookieService,
    MatTree,
    Location,
    {
      provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true
    },
    {
      provide: ErrorHandler, useClass: AppErrorHandler
    },
    {
      provide: LocationStrategy, useClass: HashLocationStrategy
    }
  ]
})

export class AppModule {
}
